define('presentation/welcome/viewModels/teamMemberViewModel',[
], function () {
    return function (parent) {

        let self = this;

        self.parent = parent;


        self.index = 0;
        self.name = ko.observable('').extend({ rateLimit: 500 });
        self.title = ko.observable('').extend({ rateLimit: 500 });

        self.isEmpty = ko.pureComputed(() => self.name().trim() === '' && self.title().trim() === '');

        self.onRemoveTeamMemberClick = () => {
            self.parent.onRemoveTeamMemberClick(self);
        };
    };
});
